class MaxQuantityThreshold extends HTMLElement {
  static observedAttributes = ["max-quantity", "quantity-requested"];

  constructor() {
    super();
  }

  attributeChangedCallback() {
    this._init();
  }

  _init() {
    const max = this.maxQuantity;
    this.style.display =
      max > 0 && this.quantityRequested >= max ? null : "none";
  }

  get maxQuantity() {
    return parseInt(this.getAttribute("max-quantity") || "0");
  }

  get quantityRequested() {
    return parseInt(this.getAttribute("quantity-requested") || "1");
  }
}

if (!customElements.get("max-quantity-threshold")) {
  customElements.define("max-quantity-threshold", MaxQuantityThreshold);
}
